import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "app/hooks";

export function RequireAuth({ children, permission }: { children: JSX.Element, permission?: string }) {
  let user = useAppSelector((state) => state.user);
  let location = useLocation();

  if (!user.isLoggedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission) {
    if (user.roleName !== permission) {
      return <Navigate to="/assessments" state={{ from: location }} replace />;
    }
  }

  return children;
}